/** Catálogo chino simplificado — claves planas; misma estructura que en.ts */
const zh = {
  unique_death_history: "击杀记录",
  reg_events: "活动",
  reg_details: "说明与奖励",
  reg_details_pending: "详情即将公布。",
  reg_open: "开放",
  reg_closed: "关闭",
  reg_joined: "已报名",
  reg_equalized: "均衡模式",
  reg_standard: "普通模式",
  reg_cancel_registration: "取消报名",
  reg_joined_hint: "你已报名参加此活动。",
  reg_open_hint: "报名已开放，点击报名即可参加。",
  reg_closed_hint: "报名已关闭。",
  reg_translating: "翻译中…",
  reg_translation_error: "翻译暂不可用，显示原文。",
  reg_retry: "重试",

  battle_pass: '战斗通行证',
  menu_main: '主菜单',
  menu_tools: '工具',
  menu_open: '打开菜单',
  menu_close: '关闭菜单',
  menu_home: '返回主页',
  guide: '指南',
  daily_login: '每日登录',
  spin_title: '转盘',
  special_offer: '特别优惠',
  auction_system: '拍卖行',
  title_manager: '个性化',
  ranking: '排名',
  unique: '独特',
  job_system: '工作系统',
  vip_system: 'VIP',
  donation: '捐赠',
  surveys: '问卷',
  settings: '设置',
  messages: '消息',
  unique_status_title: '当前状态',
  unique_logs_title: '历史记录',
  unique_table_name: '独特',
  unique_table_character: '角色',
  unique_table_status: '状态',
  unique_table_event: '事件',
  unique_table_map: '地图',
  unique_table_time: '时间',
  unique_status_alive: '存活',
  unique_status_dead: '已击杀',
  unique_event_spawn: '刷新',
  unique_event_death: '击杀',
  unique_refresh: '刷新',
  unique_sort_alive_first: '排序：存活优先',
  unique_sort_dead_first: '排序：已死亡优先',
  unique_deaths_tooltip_title: '最近5次击杀',
  unique_deaths_empty: '暂无击杀记录',
  unique_load_error: '无法加载独特历史记录。',
  unique_no_data: '未找到数据。',
  unique_logs_empty: '暂无历史事件。',
  schedule: '日程',
  sched_no_events: '暂无计划活动。',
  sched_running: '进行中',
  sched_load_error: '无法加载日程，请稍后再试。',
  reg_register: '注册',
  reg_remove_register: '取消注册',
  reg_processing: '处理中...',
  reg_registered_success: '您已成功注册活动',
  reg_unregistered_success: '您已成功取消活动注册',
  reg_no_events: '没有可用活动。',
  reg_load_error: '无法加载活动，请稍后再试。',
  reg_error_invalid_event: '无效活动',
  reg_error_not_logged_in: '您必须登录才能注册活动',
  reg_error_not_available: '活动不可用于注册',
  reg_error_already_registered: '注册活动时出错。您可能已经注册。',
  reg_error_unregister: '取消活动注册时出错',
  reg_error_processing: '处理请求时出错',
  reg_error_connection: '连接错误。请重试。',
  reg_modal_title: 'Equalized System',
  reg_weapons: '武器（选择1个）',
  reg_buffs: '增益（选择1个）',
  reg_essence: 'Essence（始终激活）',
  reg_force: 'Force（始终激活）',
  reg_btn_register: '注册',
  reg_btn_cancel: '取消',
  register: '注册',
  r_ia: 'R-AI',
  chat_welcome_message: '你好！👋 我是 <strong>R-AI</strong>，您的丝路起源 AI 助手。',
  chat_welcome_question: '今天我能帮您什么？',
  chat_input_placeholder: '输入消息...',
  chat_send_button: '发送',
  chat_send_title: '发送消息',
  chat_char_count: '{current} / {max}',
  chat_load_error: '无法加载聊天记录，请稍后再试。',
  chat_error_connection: '连接错误。请重试。',
  drop_log: '掉落记录',
  log_table_item: '物品',
  log_table_character: '角色',
  log_table_monster: '怪物',
  log_table_map: '地图',
  log_table_date: '日期',
  log_table_ago: '前',
  log_search_placeholder: '搜索...',
  log_time_seconds: '秒',
  log_time_minutes: '分',
  log_time_hours: '时',
  log_time_days: '天',
  log_filter_race: '种族',
  log_filter_race_chinese: 'Chinese',
  log_filter_race_euro: 'Euro',
  log_filter_type: '类型',
  log_filter_time_all: '全部',
  log_filter_time_today: '今天',
  log_filter_time_week: '本周',
  log_filter_time_month: '本月',
  log_filter_apply: '应用',
  log_filter_reset: '重置',
  log_load_error: '无法加载掉落记录，请稍后再试。',
  log_no_results: '没有符合筛选条件的掉落。',
  log_modal_i_need_it: '我需要它',
  log_modal_sending: '发送中...',
  log_modal_sent: '已发送',
  log_modal_error: '错误',
  log_modal_connection_error: '连接错误',
  log_modal_message_template: '嗨，我对您掉落的 {item} 感兴趣。您要多少？',
  log_chat_button_title: '通过聊天联系',
  log_chat_self_error: '不能给自己发消息',
  languages: '语言',
  server_time: '服务器时间',
  loading_data: '加载数据中...',
  auth_loading: '认证中...',
  auth_error: '无法认证。请从游戏中重新打开。',
  bp_duration: '持续时间：{start} - {end}（剩余 {remaining}）',
  bp_level: '等级',
  bp_buy_pass: '购买通行证',
  bp_premium_active: '高级通行证已激活',
  bp_premium_reward: '高级奖励',
  bp_max_level: '最高等级：{level}',
  bp_no_active: '没有激活的战斗通行证',
  bp_reward_success: '奖励领取成功！',
  bp_claim_error: '无法领取奖励，请稍后再试。',
  bp_exp_info_title: '战斗通行证经验',
  bp_exp_tower_defense_victory: '塔防：胜利：45分 | 失败：5分',
  bp_exp_hell_prison_victory: '地狱监狱：胜利：50分 | 失败：10分',
  bp_exp_witch_hunt_victory: '女巫狩猎：胜利：50分 | 失败：10分',
  bp_exp_survival: '生存：第1名：30分 | 第2名：15分 | 第3名：5分',
  bp_exp_last_man_standing: '最后一人：胜利：95分',
  bp_exp_madness: '疯狂：第1名：30分 | 第2名：15分 | 第3名：5分',
  bp_exp_garden_job_victory: '花园（工作）：胜利：50分 | 失败：10分',
  bp_exp_capture_flag_victory: '夺旗：胜利：50分 | 失败：10分',
  bp_exp_battle_arena_victory: '战斗竞技场：胜利：50分 | 失败：10分',
  bp_exp_league_map_victory: '联赛地图：胜利：55分 | 失败：10分',
  bp_exp_medusa_victory: 'Medusa：胜利：100分 | 失败：20分',
  bp_exp_roc_victory: 'Roc：胜利：100分 | 失败：20分',
  bp_exp_normal_uniques_victory: '普通Uniques：胜利：5分 | 失败：3分',
  bp_exp_arabian_uniques_victory: '阿拉伯Uniques：胜利：7分 | 失败：5分',
  bp_exp_legendary_uniques_victory: '传奇Uniques：胜利：10分 | 失败：7分',
  bp_exp_job_kills: '工作击杀：每次击杀2分',
  bp_exp_job_delivery: '工作交付：每次交付15分',
  bp_exp_global_chat: '全局聊天使用：每次使用2分',
  bp_exp_summary:
    '通过活动获得战斗通行证经验：塔防、地狱监狱、女巫狩猎、生存、疯狂、花园工作、夺旗、战斗竞技场、联赛地图、Medusa、Roc、Uniques、工作击杀/交付及全局聊天。',
  silk_confirm_cost: '费用：{amount} 丝绸',
  silk_confirm_balance: '您的余额：{amount} 丝绸',
  silk_confirm_after: '购买后余额：{amount} 丝绸',
  silk_confirm_not_enough: '您的丝绸不足以完成此次购买。',
  silk_confirm_cancel: '取消',
  silk_confirm_confirm: '确认',
  bp_premium_confirm_title: '购买高级通行证',
  bp_premium_confirm_msg: '解锁本赛季所有高级奖励。',
  bp_levelup_confirm_title: '升级',
  bp_levelup_confirm_msg: '立即获得一个战斗通行证等级。',
  silk_confirm_price_label: '价格',
  silk_confirm_your_silk: '您的丝绸',
  silk_confirm_checking: '检查中...',
  silk_confirm_unavailable: '不可用',
  silk_confirm_retry_later: '稍后重试',
  silk_confirm_not_enough_short: '丝绸不足',
  silk_confirm_processing: '处理中',
  silk_confirm_processing_msg: '正在处理您的购买...',
  silk_confirm_success: '成功',
  silk_confirm_failed: '失败',
  silk_confirm_wait: '请稍候',
  silk_confirm_close: '关闭',
  cal_schedule_label: '签到日程：{start} - {end}',
  cal_remaining_label: '（剩余 {remaining}）',
  cal_checked_in_status: '已签到 {checked} / {total} 天（错过 {missed} 天）',
  cal_day_label: '第 {day} 天',
  cal_checkin_available: '您现在可以签到！',
  cal_next_checkin: '下次签到：{hours}小时 {minutes}分钟后',
  cal_claim_error: '无法完成操作，请稍后再试。',
  cal_no_campaign: '没有活动的活动',
  spin_daily_spins: '{max} 次每日转盘（{used}/{max}）',
  spin_recent_rewards: '最近5次奖励',
  spin_congratulations: '恭喜！',
  spin_probability: '概率：',
  spin_daily_reached_tooltip: '今日次数已用完。如需再次使用，请用丝绸购买。',
  spin_reset_confirm_title: '确认重置',
  spin_reset_confirm_message: '确定要重置转盘次数吗？',
  spin_reset_confirm_silk: '{amount} 丝绸',
  spin_reset_confirm_cancel: '取消',
  spin_reset_confirm_confirm: '确认',
  spin_reset_success: '转盘次数重置成功！',
  spin_reset_error: '无法重置转盘次数。',
  spin_error_spin: '无法转动转盘。',
  spin_error_winner: '未找到获奖物品。',
  spin_error_connection: '与服务器连接出错。',
  so_title: '特别优惠',
  so_recommended: '推荐',
  so_offer_ends_in: '优惠结束于',
  so_buy: '购买',
  so_available: '可用',
  so_sold_out: '售罄',
  so_processing: '处理中...',
  so_purchase_success: '购买成功！',
  so_purchase_error: '购买错误',
  so_network_error: '网络错误',
  so_confirm_title: '确认购买',
  so_confirm_message: '购买 {name}？',
  so_no_offers: '没有活动优惠',
  auc_time_left: '剩余时间',
  auc_bid_concluded: '竞拍结束',
  auc_winner: '获胜者',
  auc_auction_starting_soon: '拍卖即将开始',
  auc_enter_bid: '输入您的出价',
  auc_bid_now: '立即出价',
  auc_be_first_to_bid: '成为第一个出价者',
  auc_current_bid: '当前出价',
  auc_by: '由',
  auc_latest_bids: '最新出价',
  auc_auction_ended: '拍卖已结束。恭喜获胜者！',
  auc_wait_next_auction: '请等待下一场拍卖开始。',
  auc_item_rewards: '物品奖励',
  auc_no_rewards: '没有可用奖励',
  auc_bid_success: '出价成功！',
  auc_bid_error: '出价时出错。',
  auc_invalid_bid: '请输入有效的出价金额。',
  tm_tab_name: "Name",
  tm_name_colors: "已保存的名字颜色",
  tm_name_apply: "应用颜色",
  tm_name_select: "选择颜色",
  tm_name_empty: "暂无已保存的颜色。",
  tm_name_reuse: "每种颜色售价999 Silks。购买后可免费重复使用。每次自定义更改需间隔30秒。",
  tm_name_buy: "购买名字颜色",
  tm_name_purchased: "名字颜色已购买。",
  tm_name_applied: "名字颜色已应用。",
  tm_name_owned: "已拥有",
  tm_name_error: "无法处理颜色。",
  tm_cooldown: "请等待{seconds}秒后再更改。",
  tm_tab_title: '称号',
  tm_tab_icon: '图标',
  tm_tab_tag: '标签',
  tm_title_column: '称号',
  tm_tag_column: '标签',
  tm_actions_column: '操作',
  tm_enter_title: '输入称号文本...',
  tm_enter_tag: '输入标签文本...',
  tm_test: '测试',
  tm_edit: '编辑',
  tm_edit_title_modal_title: '编辑称号',
  tm_price_edit: '编辑价格',
  tm_error_editing_title: '编辑称号时出错。',
  tm_title_edited: '称号已成功更新。',
  tm_buy: '购买',
  tm_total_pay: '应付总额',
  tm_color_optional: '自定义颜色（可选）',
  tm_edit_separate: '编辑现有称号（另计）',
  tm_price_title: '称号价格',
  tm_price_color: '颜色价格',
  tm_price_tag: '标签价格',
  tm_price_icon_label: '{amount} 丝绸',
  tm_apply_title: '应用称号',
  tm_remove_title: '删除称号',
  tm_apply_tag: '应用标签',
  tm_remove_tag: '删除标签',
  tm_no_titles: '没有已保存的称号。',
  tm_no_tags: '没有已保存的标签。',
  tm_no_icons: '没有找到图标。',
  tm_icon_search: '搜索图标...',
  tm_icon_left: '左图标',
  tm_icon_right: '右图标',
  tm_buy_title_modal_title: '确认购买称号',
  tm_buy_tag_modal_title: '确认购买标签',
  tm_buy_icon_modal_title: '确认购买图标',
  tm_buy_title_label: '称号：',
  tm_buy_tag_label: '标签：',
  tm_buy_icon_label: '图标：',
  tm_buy_price_label: '价格：',
  tm_buy_balance_label: '您的余额：',
  tm_buy_includes: '包含：',
  tm_buy_includes_title_color: '称号 + 自定义颜色',
  tm_buy_not_enough: '⚠ 您的丝绸不足。',
  tm_buy_needs_more: '您还需要 {amount} 丝绸。',
  tm_buy_confirm: '确认购买',
  tm_buy_cancel: '取消',
  tm_error_testing_title: '测试称号时出错。',
  tm_error_buying_title: '购买称号时出错。',
  tm_error_buying_tag: '购买标签时出错。',
  tm_error_buying_icon: '购买图标时出错。',
  tm_error_applying_icon: '应用图标时出错。',
  tm_error_getting_balance: '获取丝绸余额时出错。',
  tm_error_applying_title: '应用称号时出错。',
  tm_error_applying_tag: '应用标签时出错。',
  tm_error_removing_title: '删除称号时出错。',
  tm_error_removing_tag: '删除标签时出错。',
  tm_processing: '处理中...',
  tm_already_have_title: '您已拥有此称号。',
  tm_already_have_tag: '您已拥有此标签。',
  tm_already_have_icon: '您已拥有此图标。',
  tm_not_enough_silk: '丝绸不足。',
  tm_title_applied: '称号应用成功。',
  tm_title_purchased: '称号购买成功！享受您的新称号。',
  tm_tag_applied: '标签应用成功。',
  tm_icon_applied: '图标应用成功。',
  tm_title_removed: '称号已成功停用。',
  tm_tag_removed: '标签已成功删除。',
  tm_icon_purchased: '图标购买成功。',
  tm_test_applied: '称号预览已应用（临时）。',
  ranking_search_placeholder: '搜索玩家...',
  ranking_filter_race: '种族',
  ranking_race_chinese: 'Chinese',
  ranking_race_euro: 'Euro',
  ranking_filter_mastery: '专精',
  ranking_mastery_bicheon: 'Bicheon',
  ranking_mastery_pacheon: 'Pacheon',
  ranking_mastery_heuksal: 'Heuksal',
  ranking_mastery_warrior: '战士',
  ranking_mastery_rogue: '盗贼',
  ranking_mastery_wizard: '法师',
  ranking_filter_reset: '重置',
  ranking_filter_refresh: '刷新排名',
  ranking_col_character: '角色',
  ranking_col_guild: '公会名称',
  ranking_col_points: '积分',
  ranking_no_results: '没有符合筛选条件的玩家。',
  ranking_empty: '排名数据暂不可用，请稍后再试。',
  ranking_error: '无法加载排名。点击 ↺ 重试。',
  ranking_error_auth: '无法加载排名。点击 ↺ 重试。',
  ranking_player_title: '玩家排名',
  ranking_guild_title: '公会排名',
  ranking_mastery_title: '专精排名',
  ranking_arena_title: '竞技场 PVP 排名',
  ranking_profile_loading: '正在加载角色资料...',
  ranking_profile_error_title: '错误',
  ranking_profile_error_message: '无法加载角色资料。',
  ranking_profile_back: '返回排名',
  ranking_profile_inventory: '背包',
  ranking_profile_avatar: '头像',
  ranking_profile_level: '等级',
  ranking_profile_strength: '力量：',
  ranking_profile_intelligence: '智力：',
  ranking_profile_guild: '公会：',
  ranking_profile_no_guild: '<无>',
  job_level: '等级',
  job_daily_progress: '每日工作进度',
  job_claimed: '已领取',
  job_completed: '已完成',
  job_in_progress: '进行中',
  job_gold: '金币',
  job_min: '分钟',
  job_delivery_history: '今日交付历史',
  job_route: '路线',
  job_gold_earned: '获得金币',
  job_delivery_time: '交付时间',
  job_delivery_hour: '交付时刻',
  job_no_deliveries_today: '今天没有注册的交付。',
  job_no_job_info: '您的角色没有可用的工作信息。',
  job_login_required: '您必须登录才能查看工作进度。',
  job_hwid_error: '无法检索硬件信息。',
  job_level_error: '无法检索工作等级。',
  job_no_configuration: '此工作类型没有可用配置。',
  job_merchant: '商人',
  job_thief: '盗贼',
  job_hunter: '猎人',
  job_unknown: '未知',
  job_invalid_data: '无效数据',
  job_already_claimed_today: '您今天已经领取了奖励。',
  job_complete_progress_first: '领取奖励前必须完成每日进度。',
  job_no_reward_for_level: '您当前等级没有可用奖励。',
  job_reward_claimed_success: '奖励领取成功。',
  job_success: '成功',
  job_error: '错误',
  job_network_error: '网络错误',
  job_protected_cargo: '受保护的商货',
  job_stolen_cargo: '被盗的商货',
  cupon_title: '优惠券',
  cupon_level_required: '等级',
  cupon_rewards_title: '优惠券奖励',
  cupon_expires_in: '到期时间',
  cupon_claim_button: '领取优惠券',
  cupon_claimed_button: '已领取',
  cupon_confirm_button: '确认',
  cupon_resend_button: '重新发送验证码',
  cupon_verification_title: '输入验证码',
  cupon_choose_channel: 'Where should we send your code?',
  cupon_contact_missing: 'Not configured',
  cupon_whatsapp_verify: 'Verified number required',
  cupon_configure_contact: 'Configure WhatsApp in Settings',
  cupon_sent_via: 'Code sent via {channel}',
  cupon_code_sent_info: '验证码将发送到您的邮箱',
  cupon_code_sent_button: '已发送 - 请查看您的邮箱',
  cupon_coupon_claimed: '优惠券领取成功！请在游戏内查看您的宝箱。',
  cupon_no_coupons: '目前没有可用优惠券',
  cupon_already_claimed: '您已领取过此优惠券',
  cupon_request_error: '请求验证码时出错，请重试。',
  cupon_complete_code: '您必须输入完整的6位验证码',
  cupon_processing_error: '处理请求时出错，请重试。',
  cupon_sending: '发送中...',
  cupon_processing: '处理中...',
  settings_tab_general: '常规',
  settings_tab_notifications: '通知',
  settings_tab_restrictions: '限制',
  settings_label_language: '语言',
  settings_label_timezone: '时区',
  settings_label_country: '国家',
  settings_label_whatsapp: 'WhatsApp',
  settings_btn_verify: '验证',
  settings_btn_confirm: '确认',
  settings_btn_save: '保存',
  settings_btn_validate_now: '立即验证',
  settings_btn_validate_whatsapp: '通过 WhatsApp 验证',
  settings_btn_validate_authenticator: '通过验证器验证',
  settings_placeholder_code: '验证码',
  settings_placeholder_phone: '1234567890',
  settings_no_events: '未配置事件',
  settings_minutes_before: '分钟前',
  settings_time_remaining: '距离下次验证所需的剩余时间',
  settings_validation_warning: '您的验证即将过期。立即续期以继续无中断游戏。',
  settings_validation_active: '您的连接已验证并处于活动状态。',
  settings_validation_expired: '您必须验证连接才能在游戏中移动。',
  settings_coming_soon: '（即将推出）',
  settings_no_hwid: '无法获取 HWID。请登录游戏。',
  settings_code_sent: '验证码已发送。请查看您的 WhatsApp。',
  settings_whatsapp_verified_success: 'WhatsApp 验证成功',
  settings_error_update_config: '更新配置时出错',
  settings_error_phone_required: '请输入电话号码',
  settings_error_code_required: '请输入有效的6位验证码',
  settings_error_send_code: '发送验证码时出错',
  settings_error_verify_code: '验证代码时出错',
  settings_error_validate_connection: '验证连接时出错',
  settings_error_code_incorrect: '验证码不正确',
  settings_no_results: '未找到结果',
  settings_searching: '搜索中...',
  messages_page_title: '聊天',
  messages_conversations: '对话列表',
  messages_new_chat: '新建聊天',
  messages_search_player: '搜索玩家...',
  messages_type_message: '输入消息...',
  messages_send: '发送',
  messages_attach_item: '附加物品',
  messages_online: '在线',
  messages_offline: '离线',
  messages_no_messages: '暂无消息',
  messages_no_conversations: '没有对话',
  messages_loading: '加载中...',
  messages_error_send: '发送消息时出错',
  messages_error_load: '加载消息时出错',
  messages_retry: '重试',
  messages_select_player: '选择一名玩家开始聊天',
  messages_select_item: '选择物品',
  messages_item_attached: '物品已附加',
  messages_remove_item: '移除物品',
  messages_confirm: '确认',
  messages_cancel: '取消',
  messages_today: '今天',
  messages_yesterday: '昨天',
  messages_typing: '正在输入...',
  messages_translate: '翻译',
  messages_show_original: '显示原文',
  messages_translate_error: '无法翻译消息',
  messages_scroll_for_more: '向上滚动查看更多消息',

  notifications_title: '通知',
  notifications_no_notifications: '没有可用通知',
  notifications_no_type: '无类型',
  notifications_published: '发布时间：',
  notifications_expires: '过期时间：',
  notifications_like: '喜欢',
  notifications_dislike: '不喜欢',
  notifications_back_to_notifications: '返回通知',
  notifications_vote_error: '更新投票时出错',
  notifications_loading: '加载中...',
  notifications_error_load: '加载通知时出错',
  notifications_not_found: '通知未找到或不可用',

  dt_title: '每日任务',
  dt_global_progress: '总体进度',
  dt_tasks_completed: '任务已完成',
  dt_no_tasks: '目前没有可用任务。',
  dt_claimed: '已领取',
  dt_incomplete: '未完成',
  dt_final_rewards: '最终奖励',
  dt_final_rewards_description:
    '完成所有每日任务并领取所有奖励，以解锁这些最终奖励。',
  dt_claim_final_reward: '领取最终奖励',
  dt_complete_all_first: '您必须先完成并领取所有每日任务',
  dt_success: '成功',
  dt_error: '错误',
  dt_network_error: '网络错误',
  dt_processing: '处理中...',
  dt_login_required: '您必须登录才能查看每日任务。',
  dt_load_error: '无法加载每日任务。',

  don_package: '套餐：',
  don_silks: '丝绸：',
  don_price: '价格：',
  don_silks_label: '丝绸',
  don_vip_points: '{amount} VIP积分',
  don_promo: '促销',
  don_special_offer: '特别优惠',
  don_back: '← 返回',
  don_pay: '支付 $',
  don_continue_paypal: '前往 PayPal',
  don_processing: '处理中...',
  don_binance_soon: 'Binance 支付即将推出...',
  don_error_create: '创建支付失败',
  don_stripe_not_loaded: 'Stripe SDK 未加载',
  don_success_processing: '正在处理支付...',
  don_success_wait: '请稍候，正在确认您的捐赠。',
  don_success_ok: '支付成功！',
  don_success_fail: '支付未完成',
  don_success_fail_msg: '无法确认您的捐赠，请重试。',
  don_cancel_title: '支付已取消',
  don_cancel_msg: '捐赠未完成，您可以随时重试。',
  don_back_to: '返回捐赠',
  don_credited: '已向您的账户充值 {amount} 丝绸。',
  cal_claimed: '已领取',
  cal_locked: '未解锁',
  cal_today: '今天',
  cal_claim: '领取',
  cal_streak_label: '已签到天数',
  cal_consecutive_login: '连续登录',
  cal_upcoming: '即将到来',
  cal_upcoming_rewards: '即将获得的奖励',
  cal_no_upcoming: '暂无',
  cal_monthly_bonus: '月度奖励',
  cal_monthly_bonus_desc: '签到 {days} 天即可领取月度奖励。',
  cal_days_remaining: '剩余 {days} 天',
  cal_day_remaining: '剩余 1 天',
  cal_info_title: '活动说明',
  cal_default_desc: '每日登录领取专属奖励。错过一天？继续前进，帝国等待你的归来。',
  cal_prev: '上一个',
  cal_next: '下一个',
  cal_bonus_days_unit: '天',
  cal_bonus_n_day: '1天',
  cal_bonus_n_days: '{days}天',
  cal_bonus_7_days: '7天',
  cal_bonus_15_days: '15天',
  cal_bonus_1_month: '1个月',
  bp_multiple_items: '多个物品可选',
  vip_title: 'VIP系统',
  vip_col_level: '等级',
  vip_col_progress: '进度',
  vip_col_rewards: '奖励',
  vip_col_state: '状态',
  vip_level_label: 'VIP等级 ({level})',
  vip_state_unlocked: 'Unlocked',
  vip_no_levels: 'No VIP levels configured.',
  vip_points_rate: '{points} VIP Points.',
  vip_your_points: 'Your points',
  vip_current_level: 'Current level',
  vip_next_level: 'Next level',
  vip_all_unlocked: 'All levels unlocked',
  vip_points_remaining: '{points} points to go',
  vip_information: 'VIP information',
  vip_close: 'Close',
  vip_info_account: 'VIP points belong to your account. Only completed donations with credited VIP points count.',
  vip_info_unlock: 'Reach the required points to unlock each level. Your points accumulate and are not spent when a level unlocks.',
  vip_info_rewards: 'Unlocked means you meet the requirement. Reward claiming and delivery are not available yet.',
  vip_state_locked: '未解锁',
  vip_note: '每捐赠 $1，您将获得',
  vip_note_points: '10 VIP积分。',
  don_history: "购买记录",
  don_history_loading: "正在加载购买记录...",
  don_history_error: "无法加载购买记录。",
  don_history_empty: "暂无购买记录。",
  don_history_date: "日期",
  don_history_method: "支付方式",
  don_history_status: "状态",
  don_history_previous: "上一页",
  don_history_next: "下一页",
  don_status_completed: "已完成",
  don_status_pending: "待处理",
  don_status_cancelled: "已取消",
  don_status_failed: "失败",
  don_daily_limit: "最近24小时已消费 {current}。本次购买金额为 {amount}，累计将达到 {total}，超过限额 {limit}。还可消费 {remaining}。",
  don_limit_available: "可用额度：{amount}",
  don_reset_ready: "最近24小时的付款",
  don_reset_updating: "正在更新额度...",
  don_reset_error: "无法获取额度",
  don_reset_in: "距离重置 {time}",
  don_limit_locked: "已达到付款限额。请等待顶部倒计时结束后再付款。",
} as const;

export default zh;
